import React from 'react';
import { Navigate } from 'react-router-dom';
import { useConfig } from '../contexts/ConfigContext';

/**
 * Public sign-up is disabled by default in invite-only mode.
 * If a visitor lands on /signup we redirect them to the pilot request form
 * (or the landing page if pilot requests are also disabled).
 */
export default function Signup() {
  const { config, loading } = useConfig();
  if (loading) return null;
  if (config?.enable_self_signup) {
    // If self-signup is later turned back on, we fall through to a basic landing.
    return (
      <div className="min-h-screen bg-navy-950 grid place-items-center px-6">
        <div className="text-slate-400">Self-signup will appear here when enabled.</div>
      </div>
    );
  }
  if (config?.enable_pilot_requests) return <Navigate to="/request-access" replace />;
  return <Navigate to="/" replace />;
}
